export default {
  GET_IS_OFFLINE_STATUS: (state) => {
    return state.isOfflineMode;
  },
};
